import { Component, OnInit } from '@angular/core';
import { DwComponent, DwMetaDataFilterConfigData, DwComponentType, DwFilterItemBase, DwOperator, DwQueryFilterGroup, DwQueryHelper, DwFormControlAutoCompleteServerLookupComponent } from '@devwareapps/devware-cap';
import { forEach } from 'mathjs';
import { PermitRequestActionService } from '../../actions/permit-request-create-permit-action.service';
import { PermitsMetaDataItemNames, PermitsMetaDataLookups, CodeValuePermitType } from '../../meta-data/permits-meta-data.service';

@DwComponent<DwMetaDataFilterConfigData>({

  name: 'Permit Type Custom Filter',
  componentType: DwComponentType.filterItem,
  isGlobal: false,
  parentItemName: PermitsMetaDataItemNames.PermitRequest,
  configData: {
    showCaption: true,
    showCompareType: false,
    showControlOptions: false,
    requireAttr: false,
    showPlaceholderText: false,
    showDefaultValue: false,
    allowAttr: false,
  }
})

@Component({
  selector: 'app-permit-type-filter',
  templateUrl: './permit-type-filter.component.html',
  styleUrls: ['./permit-type-filter.component.scss']
})
export class PermitTypeFilterComponent extends DwFilterItemBase {
  LookupId: number = PermitsMetaDataLookups.CodeValuePermitType;
  itemIds: number[] = [];
  fkMap: object = {};

  constructor() {
    super();
    this.fkMap[CodeValuePermitType.AccessControl] = 'HasAccessControl';
    this.fkMap[CodeValuePermitType.AudioVisual] = 'HasAudioVisual';
    this.fkMap[CodeValuePermitType.BurglarAlarm] = 'HasBurglarAlarm';
    this.fkMap[CodeValuePermitType.DataVoice] = 'HasDataVoice';
    this.fkMap[CodeValuePermitType.Electrical] = 'HasElectrical';
    this.fkMap[CodeValuePermitType.FireAlarm] = 'HasFireAlarm';
    //deprecated this.fkMap[CodeValuePermitType.Paging] = 'Paging';
    this.fkMap[CodeValuePermitType.CCTV] = 'HasCCTV';
    //this.fkMap[CodeValuePermitType.Security]  = '';
  }

  valuesChanged(ids) {
    const filterGroup = new DwQueryFilterGroup();
    const qh = new DwQueryHelper();
    filterGroup.Op = DwOperator.Or;
    ids.forEach(id => {
      if (this.fkMap[id])
        filterGroup.AddFilterOr(qh.filters.IsTrue(this.fkMap[id]))
    });
    this.filter = filterGroup;
  }
}
